<template>
  <!-- 手配日選択画面 -->
  <div>
    <t-card>
      <div>
        <t-table
          ref="odDateSelectTable"
          :data="odDateSelectTable"
          header-cell-class-name="bg-default"
          highlight-current-row
          @row-click="SelectRow"
          @row-dblclick="SelectRowAndConfirm"
          :row-class-name="TableRowClassName"
          :height="detailHeight"
          border
        >
          <t-table-column
            v-for="(column, index) in columns"
            :key="index"
            :type="column.type"
            :prop="column.prop"
            :label="column.label"
            :width="column.width"
            :align="column.align"
          >
          </t-table-column
        ></t-table>
      </div>
      <div :style="{ height: bottomHeight + 'px' }">
        <t-row type="flex" justify="end">
          <div>
            <t-col :span="24">
              <t-button
                round
                type="warning"
                class="dialogButton_confirm_120_40"
                @click="ConfirmClick"
                >{{ $t("resource.sys.sure") }}</t-button
              >
            </t-col>
          </div>
        </t-row>
      </div>
    </t-card>
  </div>
</template>
<script>
//import { DeleteOrderInfo, SearchOrderInfo } from "@/services/numberInfo";
//import { DateFormat } from "@/utils/filter";
import { Modal } from "@tellus/component";

import { t } from "@/locales";
import { GetCusMstInfo } from "@/services/customerInfo";
import {
  getAbleCusMstInfoList,
  getDialogContentHeight,
  getDialogContentHeightComm,
} from "@/utils/comFunction";
import { ShowOrderExcelOutputDialog } from "@/components/Dialog";
import { DIALOG_LINE_HEIGHT } from "@/utils/const";
import { Message } from "@tellus/component";
export default {
  data() {
    return {
      //明細情報のheight
      // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 画面と文字サイズの調整
      // detailHeight: getDialogContentHeight(
      //   500,
      //   DIALOG_LINE_HEIGHT * 0,
      //   DIALOG_LINE_HEIGHT * 1,
      //   0
      // ),
      detailHeight: getDialogContentHeightComm(
        500,
        DIALOG_LINE_HEIGHT * 0,
        DIALOG_LINE_HEIGHT * 1,
        0
      ),
      // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

      //合計情報のheight
      bottomHeight: DIALOG_LINE_HEIGHT * 1,

      odDateSelectTable: this.odDateList,
      columns: [
        // 手配日
        {
          prop: "odDate",
          label: t("resource.ORDER.ORDER_DATE"),
          // width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          align: "center",
        },
      ],

      data: null,

      currentOdDate: "",
    };
  },

  props: {
    //手配日リスト
    odDateList: {
      Type: Object,
      default: "",
    },

    obOrderNo: {
      Type: Object,
    },

    obOrderNoShow: {
      Type: Object,
    },

    SupCurrency: {
      Type: Object,
    },

    FactoryKbn: {
      Type: Object,
    },
  },

  mounted() {
    // UPD 2025/03/19 ZLL 課題_形状、素材、処理を削除したい start↓
    // this.Init();
    this.Init();
    // ADD 2025/03/19 ZLL 課題_形状、素材、処理を削除したい end↑

    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  methods: {
    //テーブルの高さを設定する
    handleResize() {
      this.detailHeight = getDialogContentHeight(
        500,
        DIALOG_LINE_HEIGHT * 0,
        DIALOG_LINE_HEIGHT * 1,
        0
      );
    },

    // ADD 2025/03/19 ZLL 課題_形状、素材、処理を削除したい start↓
    //初期化
    Init() {
      // 最初の項目をデフォルトで選択する
      if (this.odDateList.length > 0) {
        this.currentOdDate = this.odDateList[0].odDate;
      }
    },
    // ADD 2025/03/19 ZLL 課題_形状、素材、処理を削除したい end↑

    //确定ボタン
    ConfirmClick() {
      if (!this.currentOdDate) {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
        return;
      }

      ShowOrderExcelOutputDialog(
        {
          isAdd: false,
          obOrderNo: this.obOrderNo,
          obOrderNoShow: this.obOrderNoShow,
          SupCurrency: this.SupCurrency,
          FactoryKbn: this.FactoryKbn,
          obDate: this.currentOdDate,
        },
        t("resource.ORDER.ORDER_EXCEL_OUTPUT_DIALOG"),
        this.Close
      );
    },

    // ダイアログを閉じる
    Close() {
      this.$emit("cancel");
    },

    //行データのダブルクリック処理
    SelectRowAndConfirm(row, column, event) {
      this.currentOdDate = row.odDate;

      this.TableRowClassName({ row });

      this.ConfirmClick();
    },

    //行データをクリックする
    SelectRow(row, column, event) {
      //this.data = row;

      this.currentOdDate = row.odDate;

      this.TableRowClassName({ row });
    },

    //「得意先」が選択されている場合は、その行をハイライトする
    TableRowClassName({ row, rowIndex, column }) {
      if (row.odDate == this.currentOdDate) {
        this.data = row;
        return "current-row";
      } else {
        return "";
      }
    },
  },
};
</script>
<style scoped>
::v-deep .el-table .current-row > td {
  background-color: #b2d8ff;
}
</style>
